import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { Link, browserHistory} from 'react-router';
import _ from 'lodash';
import { createNewOrder, getPIMItemInfo, getTax } from '../../../redux/actions'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

class CreateWorkOrder extends Component {
    constructor(props) {
		super(props);
        this.state={
			date: null,
			minDate: moment().add(1, 'day'),
			maxDate:null,
			invalidPONumberMessage: 'PO number cannot include  `,~, | , * , >, <,  or /',
			invalidPONumberRootLevel: false,
			isDuplicatePONumber: false,
			showConfirmationPage:false,
			originalOrderNumber:'',
			rddResponse:{},
			workOrderPayload: {
				orderDate: moment().format('MM/DD/YYYY'),
				orderType: 'Standard Sales',
				deliveryMode: 'single',
				deliveryMethod: '',
				billingReference: [],
				billingAddress: null,
				shippingAddress: null,
				poNumber: '',
				requestedDeliveryDate: '',
				deliveryPhone: '',
				deliveryInstructions: ``,
				items: [],
				createdById: '',
				createdBy: '',
				email: '',
				accountNumber: '',
				showConfirmationPage:false
			},
			errorMessage:'',
			errors: {
				requestedDeliveryDateError: '',
				deliveryPhoneError: '',
				poNumberError:''
			},
        }

		this.handleRequestDeliveryDateChange = this.handleRequestDeliveryDateChange.bind(this);
		this.handleInputChanges = this.handleInputChanges.bind(this);
		this.validatePONumberCharacters = this.validatePONumberCharacters.bind(this);
		this.onBlurValidatePhoneNumber = this.onBlurValidatePhoneNumber.bind(this);
		this.handleBook = this.handleBook.bind(this);
		this.preparePayloadOfTax = this.preparePayloadOfTax.bind(this);
    }

    componentWillMount() {
        const self = this;
		const { createWorkOrderPayload } = self.props.state.order;
		if (!createWorkOrderPayload) {
			browserHistory.push('/manageorders');
		} else {
			self.setState({
				workOrderPayload: {
					...createWorkOrderPayload,
					deliveryInstructions:`Original CSO - ${createWorkOrderPayload.orderNumber}`,
					requestedDeliveryDate:'',
					orderDate: moment().format('MM/DD/YYYY')
				},
				createOrderResponse: null,
				originalOrderNumber:createWorkOrderPayload.orderNumber
			});
		}
	}

    handleInputChanges(event) {
        const self = this;
		const paramName = event.target.name;
		const { errors } = self.state;
		const value = paramName === 'poNumber' ? event.target.value.toUpperCase() : event.target.value;
		self.setState({
			workOrderPayload: {
				...self.state.workOrderPayload,
				[paramName]: value
			},
		}, () => {
			if(errors[paramName + 'Error']) {
				self.setState({
					errors: {
						...self.state.errors,
						[paramName+"Error"]: ""
					}
				});
			}
		});
    }

	validatePONumberCharacters(event) {
		const self = this;
		self.setState({
			invalidPONumberRootLevel: !self.props.isValidPONumberCharacter(event)
		});
	}

	onBlurValidatePhoneNumber(event) {
		const self = this;
		const phoneNumber = event.target.value;
		self.setState({
			workOrderPayload: {
				...self.state.workOrderPayload
			},
		}, () => {
			if(self.props.isValidPhoneNumber(phoneNumber)) {
				self.setState({
					workOrderPayload: {
						...self.state.workOrderPayload,
						deliveryPhone: self.props.normalizePhoneNumber(phoneNumber)
					}
				});
			}
		});
	}

    handleRequestDeliveryDateChange(date){
        const self = this;
        self.setState({
			date: date ? date.hours(0).minutes(0).seconds(0).milliseconds(0) : date,
			workOrderPayload: {
				...self.state.workOrderPayload,
				requestedDeliveryDate: date && date.format('MM/DD/YYYY')
			}
		}, () => {
			const { errors } = self.state;
			if (errors.requestedDeliveryDateError) {
				self.setState({
					errors: {
						...self.state.errors,
						requestedDeliveryDateError: ""
					}
				});
			}
		});
		let splitZip = self.state.workOrderPayload.shippingAddress.zip.indexOf("-") !== -1 ?self.state.workOrderPayload.shippingAddress.zip.split("-")[0]:self.state.workOrderPayload.shippingAddress.zip
		splitZip && self.props.getShippingAddressesDetails(splitZip, false,"sds_loc", resp => {
			self.setState({
				rddResponse:resp
			})
		}, true,self.state.workOrderPayload.shippingAddress.state, self.props.getSelectedAccountNumber(), date && date.format('MM/DD/YYYY'));
    }

	preparePayloadOfTax(deliveryItems, workOrderPayload) {
		const self = this;
		deliveryItems = JSON.parse(JSON.stringify(deliveryItems));
		workOrderPayload = JSON.parse(JSON.stringify(workOrderPayload));
		let quantity = 0;
		let orderSubTotal = 0.00;
		let finalItems = [];
		const { items } = workOrderPayload;
		items.forEach((itm)=>{
			let extendedPrice = itm.servicePrice * itm.quantity;
			finalItems.push({
				item: itm.service,
				itemDescription: itm.serviceDescription,
				quantity: itm.quantity,
				selected: itm.selected,
				productCode: itm.productCode,
				feature1: itm.feature1,
				itemCategory: itm.itemCategory,
				extendedPrice: extendedPrice
			});
		})
		deliveryItems.forEach(item => {
			item.requestedDeliveryDate = workOrderPayload.requestedDeliveryDate;
			if(item.quantity) {
				quantity += parseInt(item.quantity, 10);
				if(item.price) {
					orderSubTotal += parseFloat(parseFloat(item.quantity * item.price).toFixed(2));
				}
			}
			item.relatedServices && item.relatedServices.forEach(itm => {
				orderSubTotal += parseFloat(itm.extendedPrice);
			});
		});
		let payload = {
			...workOrderPayload,
			items: finalItems.filter(item => item.item !== 'SDS TRIP'),
			quantity,
			// estimatedTax,
			orderSubTotal,
			orderTotal: parseFloat(orderSubTotal).toFixed(2),
			pointValue: "0.00",
			orderWeight: "0.00",
			shipFromAddress: workOrderPayload.shippingAddress,
			customerType: self.props.getSelectedAccountType()
		};

		return payload;
	}

	getUnsocClassifications(callback) {
		const self = this,
			{ items } = self.state.workOrderPayload;
		let skuListForPim = [];
		items.forEach(item => {
			skuListForPim.push(item.service);
		});
		skuListForPim = _.uniq(skuListForPim);
		self.props.getPIMItemInfo(skuListForPim, "requestType=getPIMItemInfo", response => {
			if(response.status) {
				const responseObject = response.responseObject ? response.responseObject : null;
				let finalProducts = [];
				self.state.workOrderPayload.items.forEach(item => {
					const pimItemData = _.find(responseObject, { item_number: item.service });
					item.productCode = (pimItemData && pimItemData.geego_unspc_classification) ? pimItemData.geego_unspc_classification : '';
					item.feature1 = (pimItemData && pimItemData.geego_feature_1) ? pimItemData.geego_feature_1 : '';
					item.itemCategory = (pimItemData && pimItemData.item_catalog_group) ? pimItemData.item_catalog_group : '';
					finalProducts.push(item);
				});
				self.setState({
					workOrderPayload: {
						...self.state.workOrderPayload,
							items: finalProducts
					}
				}, () => {
					callback && callback();
				});
			}
		});
	}


	handleBook(event) {
		event.preventDefault();
		const self = this;
		const { errors, workOrderPayload } = self.state;
		const items = [];
		let orderSubTotal = 0.00;
		self.setState({
			workOrderPayload: {
				...self.state.workOrderPayload,
				warehouseCode: self.state.rddResponse && self.state.rddResponse.agentid,
				warehouseName: self.state.rddResponse && self.state.rddResponse.dockname,
			}
		})
				
		workOrderPayload.items.forEach(item =>{
			items.push({
				item: item.service,
				itemDescription: item.serviceDescription,
				price: item.servicePrice,
				extendedPrice: item.servicePrice * item.quantity,
				quantity: item.quantity,
				isWaiveSelected: item.waiveSelected ? "Y" : "N"
			});
			orderSubTotal += parseFloat(parseFloat(item.quantity * item.servicePrice).toFixed(2));
		});
		let formError = false;
		//Reset all errors
		for(var key in errors) {
            if(!workOrderPayload[key.replace("Error","")]) {
                errors[key] = 'error';
                formError = true;
            } else {
				errors[key] = '';
			}
        }
		workOrderPayload.warehouseCode =  self.state.rddResponse && self.state.rddResponse.agentid;
		workOrderPayload.warehouseName = self.state.rddResponse && self.state.rddResponse.dockname;
		self.setState({
			errors
		}, () => {
			if (!formError) {
				items.push({
					item: "SDS TRIP",
					itemDescription: "SDS TRIP",
					quantity: 1,
					isWaiveSelected: "N"
				});
				self.getUnsocClassifications(() => {
					const taxPayload = self.preparePayloadOfTax(items, workOrderPayload);
					self.props.getTax(taxPayload, "requestType=getTax", resp => {
						if(resp.status && resp.responseObject) {
							const taxDetails = resp.responseObject;
							self.setState({
								workOrderPayload: {
									...self.state.workOrderPayload,
									orderSubTotal,
									orderTax: taxDetails.invoice.totaltaxamount,
									orderTotal: parseFloat(orderSubTotal + taxDetails.invoice.totaltaxamount).toFixed(2)
								}
							}, () => {
								const payloadData = {...self.state.workOrderPayload};
								const {userDetails} = self.props.state.user;
								delete payloadData.orderNumber;
								delete payloadData.referenceNumber;
								const payload = {
									...payloadData,
									orderStatus: 'createorder',
									items,
									deliveryMethod: "SDS Delivery Work Order",
									createdById: userDetails.sso,
									createdBy: `${userDetails.firstName} ${userDetails.lastName}`,
									emailId: userDetails.email,
								};
								// check and drop an email with payload in case back orders items are there but no lineNo added
								self.props.createNewOrder(payload, "requestType=createOrder", false, response => {
									if(response.status) {
										self.setState({
											createOrderResponse: response.responseObject,
											showConfirmationPage: true
										})
									} else {
										browserHistory.push("/error");
									}
								});
							})
						} else {
							browserHistory.push("/error");
						}
					});
				})
			}
		});
	}

	getQuantity(payload) {
		let quantity = 0;
		payload.items.forEach(item => {
			if (item.item !== 'SDS TRIP') {
				quantity += parseInt(item.quantity, 10);
			}
		});
		return quantity;
	}

render(){
	const self = this;
	const { state } = self.props;
	const { createOrderResponse, showConfirmationPage, workOrderPayload, errors } = this.state;
	const {billingAddress, shippingAddress, orderNumber} = createOrderResponse || {};
	const { selectedAccount } = this.props.state.user;
	const {items, agreementName, poNumber, deliveryPhone} = workOrderPayload;
    return (
		<div>
			{!showConfirmationPage && <div>
            	<div className="push">
					<h1 className="pageTitle">Create Work Order</h1>
                </div>
                 <div className="largePush">
					<table style={{width: '100%'}} className="formTableTypeA createOrderTableA">
						<tbody>
							<tr>
								<td style={{textAlign: 'left'}}>P.O.<br /><i className="unbold">(for your reference)</i></td>
								<td>
									<input className={errors.poNumberError} onPaste={self.props.manipulateClipBoardOfPONumber.bind(this, this.handleInputChanges, undefined, undefined)} onKeyPress={this.validatePONumberCharacters.bind(this)} id="mainPONumber"  defaultValue={self.state.workOrderPayload.poNumber} type="text" name="poNumber" onChange={this.handleInputChanges.bind(this)} maxLength={50} />
									{this.state.invalidPONumberRootLevel && <p className="bold red">{this.state.invalidPONumberMessage}</p>}
									{this.state.isDuplicatePONumber && <p className="bold importantText">You have entered a duplicate PO number</p>}
								</td>
							</tr>
							<tr>
								<td style={{textAlign: 'left'}}>
									Delivery Phone
								</td>
								<td>
									<input
										onBlur={this.onBlurValidatePhoneNumber.bind(this)}
										className={errors.deliveryPhoneError}
										value={deliveryPhone}
										onKeyPress={this.props.acceptNumbersOnly}
										id="deliveryPhone"
										type="text"
										name="deliveryPhone"
										onChange={this.handleInputChanges.bind(this)}
										maxLength={14}
									/>
								</td>
							</tr>
							<tr>
								<td style={{textAlign: 'left'}}>
									Shipping Instructions
								</td>
								<td className="containingTextArea">
									{workOrderPayload.deliveryInstructions && workOrderPayload.deliveryInstructions.length === 300
										?<span className="bold red">We are sorry, delivery instruction is limited to 300 characters.</span>
										:null
									}
									<textarea maxLength={300} rows={6} cols={40} name="deliveryInstructions" value={workOrderPayload.deliveryInstructions} onChange={this.handleInputChanges.bind(this)} />
								</td>
							</tr>
							<tr>
								<td style={{verticalAlign: 'top', textAlign: 'left'}}>
									Requested Delivery Date
								</td>
								<td>
									<div id="newOrderShipToContainer">
										<div className="newOrderShipTo move-calendar-right">
										<DatePicker className={errors.requestedDeliveryDateError} id="requestedDeliveryDate" defaultValue={self.state.minDate.format('mm/dd/yyyy')} filterDate={self.props.isWeekday} minDate={self.state.minDate} maxDate={self.state.maxDate} placeholderText="Click to select a date" selected={self.state.date} onChange={self.handleRequestDeliveryDateChange} />&nbsp;<var>(mm/dd/yyyy)</var>
										</div>
									</div>
									<div className="clear" />
								</td>
							</tr> 
						</tbody>
					</table>
					<table className="orderReviewTable dataTableType2 noRowBorders milktoast" >
						<thead>
							<tr>
								<th className="product" style={{width: '10%'}}>Product</th>
								<th className="priceSource">Sales Agreement</th>
								<th className="quantity" style={{textAlign: 'center'}}>Quantity</th>
								<th className="poNumber"style={{textAlign: 'center'}}>P.O.</th>
								<th className="price" style={{textAlign: 'right'}}>
									<span className="bold">Price</span> <br />
										<span className="unbold">(Each)</span>
								</th>
								<th className="extendedPrice" style={{textAlign: 'right'}}>
									Extended<br />Net Price
								</th>
							</tr>
							<tr><th className="toast" colSpan={6}></th></tr>
						</thead>
						<tbody>
							{items && items.map((item, index)=> {
								let extendedPrice = item.servicePrice * item.quantity;
								return (
									<tr key={index}>
										<td className="product" style={{width: '10%'}}>
											{item.service}
										</td>
										<td className="priceSource">{agreementName}</td>
										<td className="quantity" style={{textAlign: 'center'}}>{item.quantity}</td>
										<td className="poNumber" style={{textAlign: 'center'}}>{poNumber && poNumber.toUpperCase()}</td>
										<td className="price" style={{textAlign: 'right' }}>{this.props.formatMoney(item.servicePrice, 0, ".", ",", false, "$")}</td>
										<td className="extendedPrice" style={{textAlign: 'right' }}>{this.props.formatMoney(extendedPrice, 0, ".", ",", false, "$")}</td>
									</tr>
								);
							})}
						</tbody>
					</table>
					<div className="buttonContainer">
						<div className="noButtonContainer">
							<div className="blueButton noButton" defaultValue="Cancel">
								<Link style={{ color: '#FFF', textDecoration: 'none' }} to={"/manageorders"}>Cancel</Link>
							</div>
						</div>
						<div className="yesButtonContainer">
							<div className="blueButton yesButton" defaultValue="Book">
									<a style={{ color: '#FFF', textDecoration: 'none' }} onClick={self.handleBook.bind(this)}>Book</a>
							</div>
						</div>
					</div>
				</div> 
			</div>}
			{showConfirmationPage && <div className="push">
				<p className="textRight">
					<a className="withIcon withPrintIcon noUnderline bold uppercase" onClick={this.props.handlePrint} href="">Print Order Confirmation</a>
				</p>
				<div className="push">
					<h1 className="pageTitle">Order Confirmation</h1>
				</div>
				<div>
					<p className="bold">Order Reference #: {createOrderResponse.orderNumber}</p>
					<p className="bold">Account #: {selectedAccount && selectedAccount.ACCOUNTNUMBER} - {selectedAccount && selectedAccount.ACCOUNTDESCRIPTION}</p>
				</div>
				<div>
					<div className="push orderReviewColumns columns threeColumns">
						<div className="orderReviewColumn column column1">
							<p>
								<span>
									<strong>Order Reference #:</strong>&nbsp;
									{orderNumber}<br/>
								</span>
								<strong>Status</strong>:&nbsp;{`Order has been ${this.state.workOrderPayload.orderStatus === 'createorder'?'booked':'entered'}`}
								<br />
								<strong>Order Date</strong>:  {createOrderResponse.orderDate}<br />
								<strong>Order started by</strong>: {state.user.userDetails.firstName + " " + state.user.userDetails.lastName}<br />
								<strong>P.O.#</strong>:  {createOrderResponse.poNumber && createOrderResponse.poNumber.toUpperCase()}<br /><br />
								{/* Dynamic entries below, add as many as needed: */}
								{createOrderResponse.billingReference && createOrderResponse.billingReference.map((itm, indx) => {
									return <span key={indx}><strong>{itm.name}</strong>:  {itm.value}<br /></span>
								})}
							</p>
						</div>
						<div className="orderReviewColumn column column2">
							{shippingAddress && <p>
								<strong>Ship to</strong>:<br />
								{shippingAddress.address1 && shippingAddress.address1.trim()}
								{shippingAddress.address1 && shippingAddress.address1.trim() !== ""?<br/>:null}
								{shippingAddress.address2 && shippingAddress.address2.trim()}
								{shippingAddress.address2 && shippingAddress.address2.trim() !== ""?<br/>:null}
								{shippingAddress.address3 && shippingAddress.address3.trim()}
								{shippingAddress.address3 && shippingAddress.address3.trim() !== ""?<br/>:null}
								{shippingAddress.city && shippingAddress.city.trim()}, {shippingAddress.state && shippingAddress.state.trim()} {shippingAddress.zip && shippingAddress.zip.trim()}<br />
								{shippingAddress.phone && this.props.normalizePhoneNumber(shippingAddress.phone.trim())}
							</p>}
							<p>
								<strong>Delivery Phone</strong>: {createOrderResponse.deliveryPhone}<br />
								<strong>Shipping Instructions</strong>: {createOrderResponse.deliveryInstructions && createOrderResponse.deliveryInstructions.trim()}<br />
							</p>
						</div>
						<div className="orderReviewColumn column column3">
							{ billingAddress && <p>
								<strong>Bill to</strong>:<br />
								{billingAddress.addressName}<br />
								{billingAddress.address1 && billingAddress.address1.trim()}
								{billingAddress.address1 && billingAddress.address1.trim() !== ""?<br/>:null}
								{billingAddress.address2 && billingAddress.address2.trim()}
								{billingAddress.address2 && billingAddress.address2.trim() !== ""?<br/>:null}
								{billingAddress.city && billingAddress.city.trim()}, {billingAddress.state && billingAddress.state.trim()} {billingAddress.zip && billingAddress.zip.trim()}<br />
								{billingAddress.phone && this.props.normalizePhoneNumber(billingAddress.phone.trim())}<br/>
							</p>}
							<p>
								<strong>Shipping Method</strong>: {createOrderResponse.deliveryMethod}<br />
								<strong>Requested Delivery Date</strong>: {createOrderResponse.requestedDeliveryDate && this.props.formatDate(workOrderPayload.requestedDeliveryDate, 'MM/DD/YY')}<br />
							</p>
						</div>
					</div>
					<table className="orderReviewTable dataTableType2 noRowBorders milktoast" >
						<thead>
							<tr>
								<th className="product" style={{width: '10%'}}>Product</th>
								<th className="priceSource">Sales Agreement</th>
								<th className="quantity" style={{textAlign: 'center' }}>Quantity</th>
								<th className="poNumber"style={{textAlign: 'center' }}>P.O.</th>
								<th className="price" style={{textAlign: 'right' }}>
									<span className="bold">Price</span> <br />
										<span className="unbold">(Each)</span>
								</th>
								<th className="extendedPrice" style={{textAlign: 'right'}}>
									Extended<br />Net Price
								</th>
								</tr>
							<tr><th className="toast" colSpan={6}></th></tr>
						</thead>
						<tbody>
							{createOrderResponse.items.map((itm, ind) => {
								if(itm.item === "SDS TRIP") {
									return null;
								}
								return (
									<tr key={ind}>
										<td className="product" style={{width: '10%'}}>
											{itm.item}
										</td>
										<td className="priceSource">{agreementName}</td>
										<td className="quantity" style={{textAlign: 'center'}}>{itm.quantity}</td>
										<td className="poNumber" style={{textAlign: 'center'}}>{createOrderResponse.poNumber && createOrderResponse.poNumber.toUpperCase()}</td>
										<td className="price" style={{textAlign: 'right' }}>{this.props.formatMoney(itm.price, 0, ".", ",", false, "$")}</td>
										<td className="extendedPrice" style={{textAlign: 'right' }}>{this.props.formatMoney(itm.extendedPrice, 0, ".", ",", false, "$")}</td>
									</tr>
								);
							})}
						</tbody>
						<tfoot>
							<tr>
								<td  colSpan={2}>Total Services</td>
								{/* SDS TRIP Quantity should not be counted in total quantity WCP-9665 */}
								<td className="quantity" style={{textAlign: 'center'}}>{self.getQuantity(createOrderResponse)}</td>
								<td>&nbsp;</td>
								<td>&nbsp;</td>
								<td className="extendedPrice" style={{textAlign: 'right'}}>{this.props.formatMoney(createOrderResponse.orderSubTotal, 0, ".", ",", false, "$")}</td>
							</tr>
						</tfoot>
					</table>
				</div>
				<table className="subtotalTable orderReviewSubtotalTable">
					<tbody>
						<tr className="subtotal">
							<td>Subtotal:</td>
								<td className="price" style={{textAlign: 'right'}}>{this.props.formatMoney(createOrderResponse.orderSubTotal, 0, ".", ",", false, "$")}</td>
							</tr>
							<tr className="tax">
								<td>Estimated Tax:</td>
								<td className="price" style={{textAlign: 'right'}}>{this.props.formatMoney(createOrderResponse.orderTax, 0, ".", ",", false, "$")}</td>
							</tr>
							<tr className="total">
								<td>Estimated Total:</td>
								<td className="price" style={{textAlign: 'right'}}>{this.props.formatMoney(createOrderResponse.orderTotal, 0, ".", ",", false, "$")}</td>
							</tr>
					</tbody>
				</table>
			</div>}
        </div>)   
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	createNewOrder: (payload, params, useBootApi, response) => dispatch(createNewOrder(payload, params, useBootApi, response)),
	getTax: (payload, params, response) => dispatch(getTax(payload, params, response)),
	getPIMItemInfo: (payload, params, response) => dispatch(getPIMItemInfo(payload, params, response)),
});

CreateWorkOrder = connect(mapStateToProps,mapDispatchToProps)(CreateWorkOrder);
export default CreateWorkOrder;


// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/createWorkOrder.js